import React from 'react';
// Import with a different name to avoid conflict
import { handleDeleteAccount as deleteAccountUtil } from '../../utils/accountDeletion';

const DeleteConfirmModal = ({ 
  showDeleteConfirm, 
  setShowDeleteConfirm, 
  accountId,
  user,
  setError,
  processingPayment,
  setProcessingPayment
}) => {
  console.log('DeleteConfirmModal rendering, showDeleteConfirm =', showDeleteConfirm);
  
  const handleDelete = () => {
    deleteAccountUtil({
      accountId,
      user,
      setError,
      setProcessingPayment
    });
  };
  
  if (!showDeleteConfirm) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-md w-full">
        <h3 className="text-xl font-bold mb-4">Delete Account Confirmation</h3>
        <p className="mb-4">Are you sure you want to delete your account? This will:</p>
        <ul className="list-disc pl-5 mb-4 text-gray-700">
          <li>Delete all your QR codes and their scan data</li>
          <li>Delete all your shortened links and their click data</li>
          <li>Cancel any active subscriptions</li>
          <li>Remove all your user data from our systems</li>
          <li>This action cannot be undone</li>
        </ul>
        <div className="flex justify-end space-x-3">
          <button 
            onClick={() => setShowDeleteConfirm(false)}
            className="px-4 py-2 border border-gray-300 rounded shadow-sm text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button 
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded shadow-sm"
            disabled={processingPayment}
          >
            {processingPayment ? 'Deleting...' : 'Delete Account'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;